<!--
 * @Author: your name
 * @Date: 2022-04-26 10:46:59
 * @LastEditTime: 2022-09-21 09:21:09
 * @LastEditors: wangwang 2723008256@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \jzjy\src\components\myHeader.vue
-->
<template>
  <div id="container">
    <div class="content" v-html="gywm" ></div>
  </div>
</template>

<script>
import { sysinfo_info } from "../../api/http";
export default {
  data() {
    return {
      gywm:'',//关于我们
    };
  },
  created() {

    sysinfo_info({
      md5key: localStorage.getItem("md5key"),
    }).then((res) => {
      console.log(res, "系统介绍信息");
      this.gywm = res.retRes.gywm;
    });
  },
};
</script>

<style lang="less" scoped>
#container {
  background: #fff;
  overflow: hidden;
  .content {
    margin: 30px auto;
    width: 1200px;
  }
  /deep/.content{
    font-size: 14px;
  }
}
</style>